import React from 'react';
import { useReducedMotion } from 'framer-motion';
import ReactECharts from 'echarts-for-react';
import { ChartCard } from './ChartCard';
import './studysyncEChartsTheme'; // side effect: registers the 'studysync' theme
import { EscapeHatchBoundary } from './EscapeHatchBoundary';
import { FallbackTable } from './FallbackTable';
import { stripEchartsAnimation } from './motion';

/**
 * Renders the escape hatch's sanitized declarative ECharts option with the app's OWN renderer
 * (theme forced) — no Sandpack/iframe/eval. Wrapped in an error boundary that degrades to a table
 * built from the option's injected dataset rows.
 */
export function EscapeHatch({ title, option }: { title: string; option: any }) {
  const rows: any[] = Array.isArray(option?.dataset?.source) ? option.dataset.source : [];
  const columns = rows.length ? Object.keys(rows[0]) : [];
  const table = {
    columns,
    rows: rows.slice(0, 50).map((r) => columns.map((c) => (r[c] ?? null))),
  };
  // This raw model-authored option doesn't go through ResponsiveECharts, and the sanitizer leaves
  // nested per-series `animation` keys — so deep-strip them when the user prefers reduced motion.
  const reduceMotion = useReducedMotion();
  const renderedOption = reduceMotion ? stripEchartsAnimation(option) : option;
  return (
    <EscapeHatchBoundary fallback={<FallbackTable title={title} table={table} />}>
      <ChartCard title={title} downloadable>
        <ReactECharts theme="studysync" option={renderedOption} style={{ height: 280 }} notMerge />
      </ChartCard>
    </EscapeHatchBoundary>
  );
}
